import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import useMultiLanguage from "../../hook/useMultiLanguage";
import { ReactNode, useCallback, useContext, useEffect, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers/components/KTSVG";
import { DATA_WORD_TYPES, EXPORT_FILE_NAME, FORMAT_DATE, LIST_MONTH, RESPONSE_STATUS_CODE, VARIABLE_STRING } from "../constants/moduleConsts";
import { toast } from "react-toastify";
import AppContext from "../../AppContext";
import { getReportDetail } from "./services/reportServices";
import { exportToFile, getCurrentQuarter, getFullYear } from "../utils/functionUtils";
import { exportBaoCao } from "../services/exportFileServices";
import { GroupButton } from "../components/GroupButton";
import Autocomplete from "../components/input/autocomplete";
import { useFormik } from "formik";
import * as Yup from "yup";
import { IColumns, IReportInfo, ISearchDetail } from "./models/reportModels";
import TableGrouping, { IColumnsTotal } from "../components/table-grouping/TableGrouping";
import { QUARTER_LIST, REPORT_DE_XUAT_COLUMNS, REPORT_MAPING_COLUMNS, REPORT_NANG_LUONG_COLUMNS, REPORT_TYPE, REPORT_TYPE_COLLAPSE } from "./constants/reportConsts";
import { convertDataReport, convertSearchData, templateTitleReport } from "./utils/reportUtils";
import { RangeDatePicker } from "../components/input/RangeDatePicker";
import moment from "moment";
import { getDataPreviewWord, searchListWorkUnit, searchPhongBanByDonVi } from "../services/services";
import DialogPrintReportSalaryIncrease from "./components/DialogPrintReportSalaryIncrease";
import { ExportWord, ITemplateExportWord } from "../components/exportWord";
import RegularSalaryIncreases from "../profile/components/word-templates/RegularSalaryIncreases";
import TemplateNangLuongTruocHan from "./components/word-templates/TemplateNangLuongTruocHan";
import TemplateNangLuongVuotKhung from "./components/word-templates/TemplateNangLuongVuotKhung";
import { IObject } from "../models/models";
import DialogPrintReportProposal from "./components/DialogPrintReportProposal";

const decistionRaseSalaryWords: ITemplateExportWord[] = [
  {
    type: 1,
    name: "Nâng lương thường xuyên",
    componentPreview: (dataPreview) => (
      <RegularSalaryIncreases data={dataPreview} />
    )
  },
  {
    type: 2,
    name: "Nâng lương trước thời hạn",
    componentPreview: (dataPreview) => (
      <TemplateNangLuongTruocHan data={dataPreview} />
    )
  }, {
    type: 4,
    name: "Nâng lương vượt khung",
    componentPreview: (dataPreview) => (
      <TemplateNangLuongVuotKhung data={dataPreview} />
    )
  },
];

interface IProps {
  reportInfo: IReportInfo;
  handleBack: () => void;
}

function ReportDetail(props: IProps) {
  const { lang } = useMultiLanguage();
  const { reportInfo, handleBack } = props;

  const isReportSalaryIncrease = [REPORT_TYPE.NANG_LUONG].includes(reportInfo.mappingName) ? true : false;

  const isReportProposal = [REPORT_TYPE.DE_XUAT].includes(reportInfo.mappingName) ? true : false;

  const [data, setData] = useState<any[]>([]);
  const [workUnitList, setWorkUnitList] = useState<any[]>([]);
  const [columns, setColumns] = useState<IColumns[]>([]);
  const [columnsTotal, setColumnsTotal] = useState<IColumnsTotal[]>([]);
  const [titleReport, setTitleReport] = useState<string | ReactNode>("");
  const [isSalaryFund, setIsSalaryFund] = useState<boolean>(false);
  const [searchDataObj, setSearchDataObj] = useState<ISearchDetail>({} as ISearchDetail);
  const [tabNangLuong, setTabNangLuong] = useState<number>(1);
  const [tabBaoCaoDeXuat, setTabBaoCaoDeXuat] = useState<number>(1);
  const [openDialogPrintReportSalaryIncrease, setOpenDialogPrintReportSalaryIncrease] = useState<any>({
    open: false,
    dataSearchPrint: null
  });
  const [openDialogPrintReportProposal, setOpenDialogPrintReportProposal] = useState<any>({
    open: false,
    dataSearchPrint: null
  });
  const [isShowDialogExportWord, setIsShowDialogExportWord] = useState<boolean>(false);
  const [templateWord, setTemplateWord] = useState<ITemplateExportWord[] | null>(null);
  const [listDataPreview, setListDataPreview] = useState<any>([]);
  const [dataWord, setDataWord] = useState<any>({});
  const [dataChecked, setDataChecked] = useState<any>([]);
  const { setPageLoading } = useContext(AppContext);

  const getWorkUnit = useCallback(async () => {
    try {
      const { data } = await searchListWorkUnit();
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setWorkUnitList(data?.data?.content || []);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  }, [lang]);

  useEffect(() => {
    if (reportInfo && reportInfo?.mappingLevel) {
      getWorkUnit();
    }
  }, [getWorkUnit, reportInfo]);

  useEffect(() => {
    if (![REPORT_TYPE.NANG_LUONG, REPORT_TYPE.DE_XUAT].includes(reportInfo?.mappingName)) {
      const columnsByType = REPORT_MAPING_COLUMNS.find((column) => column.type === reportInfo?.mappingName);
      setColumns(columnsByType?.columns || []);
      setColumnsTotal(columnsByType?.columnsTotal || []);
      setIsSalaryFund(REPORT_TYPE.QUY_LUONG === reportInfo?.mappingName);
      if (reportInfo && reportInfo?.mappingLevel && workUnitList.length > 0) {
        initComponent();
      }
    }
  }, [reportInfo, workUnitList, tabNangLuong]);

  useEffect(() => {
    if (reportInfo?.mappingName === REPORT_TYPE.NANG_LUONG) {
      const columnsByTab = REPORT_NANG_LUONG_COLUMNS.find((report) => report.tab === tabNangLuong);
      const templateByTab = decistionRaseSalaryWords.filter((template) => template.type === tabNangLuong)
      setColumns(columnsByTab?.columns || []);
      setDataChecked([]);
      setTemplateWord(templateByTab);
      initComponent();
    }
  }, [reportInfo, tabNangLuong])

  useEffect(() => {
    if (reportInfo?.mappingName === REPORT_TYPE.DE_XUAT) {
      const columnsByTab = REPORT_DE_XUAT_COLUMNS.find((report) => report.tab === tabBaoCaoDeXuat);
      setColumns(columnsByTab?.columns || []);
      setDataChecked([]);
      initComponent();
    }
  }, [reportInfo, tabBaoCaoDeXuat])

  const initComponent = () => {
    const yearDefault = getFullYear().find((year) => Number(year?.name) === new Date().getFullYear());
    const monthDefault = Number(moment().format(FORMAT_DATE.MM));
    const quarterDefault = QUARTER_LIST.find((quarter) => quarter.code === getCurrentQuarter());
    const endDateDefault = moment(new Date()).format("YYYY-MM-DD");
    const workUnitDefault = workUnitList.length === 1 ? workUnitList[0] : null;

    let stateDefault = isReportSalaryIncrease ?
      {
        ...formik.values,
        donVi: workUnitDefault,
        tuNgay: moment().format(FORMAT_DATE.YYYY_MM_DD_INPUT),
        denNgay: moment().format(FORMAT_DATE.YYYY_MM_DD_INPUT),
      }
      : {
        ...formik.values,
        nam: yearDefault?.name || null,
        quy: Number(quarterDefault?.code) || null,
        thang: monthDefault,
        denNgay: endDateDefault || null,
        donVi: workUnitDefault
      };

    formik.setValues(stateDefault);

    const searchObj: ISearchDetail = {
      ...stateDefault,
      type: reportInfo?.mappingName,
      donViCongTacId: workUnitDefault?.id || null
    };
    updatePageData(searchObj);
  };

  const updatePageData = useCallback(async (searchData: ISearchDetail) => {
    try {
      setPageLoading(true);
      setSearchDataObj(searchData);
      switch (reportInfo?.mappingName) {
        case REPORT_TYPE.NANG_LUONG:
          searchData.loaiNangLuong = tabNangLuong;
          break;
        case REPORT_TYPE.DE_XUAT:
          searchData.loaiBaoCaoDeXuat = tabBaoCaoDeXuat;
          break;
        default:
          break;
      }
      const { donVi, ...filterSearchData } = searchData;
      const { data } = await getReportDetail(convertSearchData(filterSearchData));
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        REPORT_TYPE_COLLAPSE.includes(reportInfo?.mappingName)
          ? setData(data?.data ? convertDataReport(data?.data) : [])
          : ((isReportSalaryIncrease || isReportProposal)
            ? setData(data?.data)
            : setData(data?.data ? [data?.data] : []));

        let otherOptionTitleData = {
          quy: Number(searchData?.quy),
          nam: searchData?.nam || "",
          endDate: searchData?.denNgay || "",
          donVi: searchData?.donViCongTacId ? donVi?.name || "" : ""
        };
        setTitleReport(templateTitleReport(reportInfo, otherOptionTitleData));
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  }, [tabNangLuong, tabBaoCaoDeXuat]);

  const handleExportExcel = () => {
    exportToFile({
      exportAPI: () => exportBaoCao({ ...searchDataObj, type: reportInfo?.mappingName }),
      fileName: EXPORT_FILE_NAME.BAO_CAO,
      setPageLoading
    });
  };

  const handleSubmit = (values: ISearchDetail) => {
    const searchData: ISearchDetail = {
      ...values,
      type: reportInfo?.mappingName,
      donViCongTacId: values?.donVi?.id || null,
      departmentId: values?.phongBan?.id || null
    };
    updatePageData(searchData);
  };

  const formik = useFormik({
    initialValues: {} as ISearchDetail,
    onSubmit: handleSubmit
  });

  const handleChangeSelect = (name: string, value: any) => {
    formik.setFieldValue(name, value);
  };

  const handleTabChangeNangLuong = (key: string | null) => {
    key && setTabNangLuong(Number(key));
  };

  const handleTabChangeDeXuat = (key: string | null) => {
    key && setTabBaoCaoDeXuat(Number(key));
  };

  const handleShowExportWord = useCallback(() => {
    if (dataChecked.length === 0) {
      toast.warning(lang("TOAST.SELECT_EMPLOYEE"));
      return;
    }
    setIsShowDialogExportWord(true);
  }, [dataChecked]);

  const searchFunction = async (searchObject: IObject) => {
    try {
      setPageLoading(true);
      const { data } = await getDataPreviewWord(searchObject);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setListDataPreview(data?.data || [])
        setDataWord(data?.data?.[0]);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <div className="flex-1">
      <div className="spaces flex flex-middle flex-space-between py-12 color-primary text-uppercase">
        <GroupButton
          type="btn-back"
          handleClose={handleBack}
        />
      </div>

      <div className="report-detail spaces p-12 flex flex-column bg-white">
        {(reportInfo && reportInfo.mappingLevel) ? (
          <>
            <Form
              onSubmit={formik.handleSubmit}
              className="z-4 relative"
            >
              <Row className="align-items-start pb-4 relative z-index-2">
                <Col xs={isReportSalaryIncrease ? 3 : 3}>
                  <Autocomplete
                    lable={lang("WARNING.UNIT")}
                    options={workUnitList}
                    value={formik.values?.donVi || null}
                    name="donVi"
                    onChange={(value) => handleChangeSelect(VARIABLE_STRING.DON_VI, value)}
                  />
                </Col>
                <Col xs={isReportSalaryIncrease ? 5 : 3}>
                  <Row>
                    {isSalaryFund ? (
                      <>
                        <Col xs={6}>
                          <Autocomplete
                            lable={lang("GENERAL.YEAR")}
                            options={getFullYear(0)}
                            value={formik.values?.nam || null}
                            name="nam"
                            onChange={(value) => handleChangeSelect(VARIABLE_STRING.NAM, value?.name)}
                          />
                        </Col>
                        <Col xs={6}>
                          <Autocomplete
                            lable={lang("GENERAL.QUARTER")}
                            options={QUARTER_LIST}
                            value={formik.values?.quy || null}
                            name="quy"
                            valueSearch="code"
                            onChange={(value) => handleChangeSelect(VARIABLE_STRING.QUY, value?.code)}
                          />
                        </Col>
                      </>
                    ) : (
                      <>
                        {isReportSalaryIncrease &&
                          <Col xs={6}>
                            <Autocomplete
                              lable={lang("INPUT.DEPARTMENTS")}
                              options={[]}
                              value={formik.values?.phongBan || null}
                              name={VARIABLE_STRING.PHONG_BAN}
                              onChange={(selectedOption) => handleChangeSelect(VARIABLE_STRING.PHONG_BAN, selectedOption)}
                              urlData="data.data"
                              searchFunction={searchPhongBanByDonVi}
                              searchObject={{ id: (formik.values?.donVi as any)?.id }}
                              touched={formik.touched?.phongBan}
                              errors={formik.errors?.phongBan}
                              dependencies={[formik.values?.donVi]}
                            />
                          </Col>
                        }
                        <Col xs={isReportSalaryIncrease ? 6 : 12}>
                          <RangeDatePicker
                            label={lang("INPUT_APPOINTMENT_TIME_EFFECT")}
                            startDateName="tuNgay"
                            endDateName="denNgay"
                            handleChange={formik.handleChange}
                            value={formik.values}
                            setFieldValue={formik.setFieldValue}
                            touch={formik.touched}
                            errors={formik.errors}
                          />
                        </Col>

                      </>
                    )}
                  </Row>
                </Col>
                <Col
                  xs={isReportSalaryIncrease ? 4 : 6}
                  className="spaces flex flex-middle pt-20"
                >
                  <GroupButton typeButton="submit">
                    <i className="bi bi-funnel spaces flex fs-18 text-white mr-6"></i>
                    {lang("GENERAL.FILTER")}
                  </GroupButton>
                  <div className="flex-1 flex flex-end">
                    {isReportSalaryIncrease &&
                      <>
                        <GroupButton className="spaces mr-10" handleEvent={() => {
                          setOpenDialogPrintReportSalaryIncrease({
                            open: true,
                            dataSearchPrint: {
                              tab: tabNangLuong
                            }
                          })
                        }
                        }>
                          {lang("BTN.PRINT")}
                        </GroupButton>
                        {tabNangLuong !== 3 &&
                          <GroupButton outline className="spaces mr-10" handleEvent={() => {
                            handleShowExportWord()
                          }
                          }>
                            Xuất quyết định
                          </GroupButton>
                        }
                      </>
                    }
                    {!(isReportProposal) &&
                      <GroupButton className="spaces mr-10" outline handleEvent={handleExportExcel}>
                        <KTSVG path="/media/icons/export-excel.svg" />
                        {lang("BTN.EXPORT")}
                      </GroupButton>
                    }
                    {isReportProposal &&
                      <GroupButton className="spaces mr-10" handleEvent={() => {
                        setOpenDialogPrintReportProposal({
                          open: true,
                          dataSearchPrint: {
                            tab: tabBaoCaoDeXuat
                          }
                        })
                      }
                      }>
                        {lang("BTN.PRINT")}
                      </GroupButton>
                    }
                  </div>
                </Col>
              </Row>
              {/* Báo cáo nâng lương */}
              {isReportSalaryIncrease &&
                <Row className="align-items-start my-2 ml-2 relative">
                  <Tabs
                    activeKey={tabNangLuong}
                    defaultActiveKey={"1"}
                    id="justify-tab-example"
                    className="spaces mb-20 list-tabs list-tabs-report"
                    onSelect={handleTabChangeNangLuong}
                  >
                    {REPORT_NANG_LUONG_COLUMNS.map((tab, index) => (
                      <Tab
                        key={`tab-report-${index}`}
                        eventKey={tab.tab}
                        title={tab.shortName}
                        className="tab-content"
                        id={`${tab.tab}`}
                        mountOnEnter
                      >
                      </Tab>
                    ))}
                  </Tabs>
                </Row>
              }
              {/* Báo cáo đề xuất */}
              {isReportProposal &&
                <Row className="align-items-start my-2 ml-2 relative">
                  <Tabs
                    activeKey={tabBaoCaoDeXuat}
                    defaultActiveKey={"1"}
                    id="justify-tab-example"
                    className="spaces mb-20 list-tabs list-tabs-report"
                    onSelect={handleTabChangeDeXuat}
                  >
                    {REPORT_DE_XUAT_COLUMNS.map((tab, index) => (
                      <Tab
                        key={`tab-report-${index}`}
                        eventKey={tab.tab}
                        title={tab.shortName}
                        className="tab-content"
                        id={`${tab.tab}`}
                        mountOnEnter
                      >
                      </Tab>
                    ))}
                  </Tabs>
                </Row>
              }

              <div className="text-center">
                {isReportSalaryIncrease ?
                  <div className="text-center">
                    <p className="text-header spaces fs-20 mb-0">{REPORT_NANG_LUONG_COLUMNS.find(report => report.tab === tabNangLuong)?.name1 || ""}</p>
                    <p className="text-header spaces fs-20">{REPORT_NANG_LUONG_COLUMNS.find(report => report.tab === tabNangLuong)?.name2 || ""} {new Date().getFullYear()}</p>
                  </div>
                  : isReportProposal ? 
                  <span className="text-header spaces fs-20">{REPORT_DE_XUAT_COLUMNS.find(report => report.tab === tabBaoCaoDeXuat)?.name || ""}</span>
                  :
                  <span className="text-header spaces fs-20">{titleReport}</span>
                }
              </div>
            </Form>
            <div className="bg-white spaces mt-10 flex-1">
              <TableGrouping
                id="reportDetail"
                columns={columns || []}
                data={data || []}
                className="table-custom"
                showTotalRow={Array.isArray(columnsTotal) && columnsTotal.length > 0}
                columnsTotal={columnsTotal}
                prefixDataField="data"
                prefixTitleField="phongBanText"
                isSelect={true}
                dataChecked={dataChecked}
                setDataChecked={setDataChecked}
              />
            </div>
          </>
        ) : (
          <div className="spaces gap-0 height-100 flex-column flex-middle flex-center">
            <div className="animation-character fw-bold spaces fs-60">
              <span>C</span>
              <span>O</span>
              <span>M</span>
              <span>I</span>
              <span>N</span>
              <span>G</span>
              <span className="spaces ml-20">S</span>
              <span>O</span>
              <span>O</span>
              <span>N</span>
            </div>
            <p className="spaces fs-28">
              <KTSVG path='/media/icons/stars.svg' svgClassName='spaces w-32 h-32 text-yellow' />
              Tính năng đang phát triển
              <KTSVG path='/media/icons/stars.svg' svgClassName='spaces w-32 h-32 text-yellow' />
            </p>
          </div>
        )}
      </div>
      {openDialogPrintReportSalaryIncrease.open &&
        <DialogPrintReportSalaryIncrease
          open={openDialogPrintReportSalaryIncrease.open}
          data={data}
          dateSearch={openDialogPrintReportSalaryIncrease.dataSearchPrint}
          columns={columns}
          handleClose={() => setOpenDialogPrintReportSalaryIncrease({
            open: false,
            dataSearchPrint: null
          })}
        />
      }
      {openDialogPrintReportProposal.open &&
        <DialogPrintReportProposal
          open={openDialogPrintReportProposal.open}
          data={data}
          dateSearch={openDialogPrintReportProposal.dataSearchPrint}
          columns={columns}
          handleClose={() => setOpenDialogPrintReportProposal({
            open: false,
            dataSearchPrint: null
          })}
        />
      }
      {isShowDialogExportWord && (
        <ExportWord
          open={isShowDialogExportWord}
          dataWord={dataWord}
          handleClose={() => setIsShowDialogExportWord(false)}
          templateList={templateWord || []}
          ComponentSearch={() =>
            <Row>
              <Col xl={6}>
                <Autocomplete
                  horizontal={true}
                  lable='Chọn nhân viên để xem mẫu word'
                  options={listDataPreview}
                  getOptionLabel={(option) => option.fullName}
                  value={dataWord}
                  onChange={(value) => setDataWord(value)}
                />
              </Col>
            </Row>
          }
          getObj={{
            list: dataChecked.map((item: any) => item?.id).join(','),
            type: DATA_WORD_TYPES.SALARY_USULLY,
            loaiBaoCaoNangLuong: tabNangLuong
          }}
          searchFunction={searchFunction}
        />
      )}
    </div>
  );
}

export default ReportDetail;
